export { SlideHanziScriptTable, SlideHanziScriptTableSlot } from "#slide-hanzi-script-table";
export {
  useSlideHanziScriptTableGate,
  type SlideHanziScriptTableGate,
} from "#use-slide-hanzi-script-table-gate";
